
export default function Products() {
  const products = [
    {
      name: 'VPN Pro',
      description: 'Enterprise-grade VPN solution with military-level encryption, protecting your data across all networks with lightning-fast connection speeds.',
      image: 'https://public.readdy.ai/ai/img_res/0767d9b8e2ee4ad09fec98fdda8589e6.jpg'
    },
    {
      name: 'Smart Cleaner',
      description: 'Intelligent storage optimization tool that automatically identifies and removes unnecessary files, boosting device performance and freeing up valuable space.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20iPhone%20mockup%20displaying%20Smart%20Cleaner%20application%20with%20orange%20accent%20interface%20showing%20storage%20visualization%20and%20optimization%20dashboard%20modern%20iOS%20design%20on%20pure%20white%20background%20with%20soft%20natural%20shadow%20professional%20product%20photography&width=400&height=500&seq=product-cleaner-card&orientation=portrait'
    },
    {
      name: 'Security Suite',
      description: 'Comprehensive security solution combining real-time threat detection, privacy protection, and secure browsing for complete peace of mind.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20iPhone%20mockup%20displaying%20Security%20Suite%20application%20with%20green%20accent%20interface%20showing%20security%20dashboard%20and%20protection%20status%20modern%20iOS%20design%20on%20pure%20white%20background%20with%20soft%20natural%20shadow%20professional%20product%20photography&width=400&height=500&seq=product-security-card&orientation=portrait'
    }
  ];

  return (
    <section id="products" className="py-40 px-20 bg-white" data-product-shop>
      <div className="max-w-[1440px] mx-auto">
        <div className="mb-20">
          <h2 className="text-8xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Our<br />
            Products
          </h2>
        </div>
        
        <div className="grid grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div 
              key={index} 
              className="group bg-white border border-gray-200 rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:border-orange-500/30 cursor-pointer"
            >
              <div className="bg-white p-8 flex items-center justify-center h-96">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              
              <div className="p-8">
                <h3 className="text-3xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {product.name}
                </h3>
                <p className="text-base text-gray-600 leading-relaxed">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
